import './home.scss';

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Alert, Col, Row } from 'reactstrap';

import { useAppSelector } from 'app/config/store';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);
  return (
    <Row>
      <Col md="9">
        <h1 className="display-4">
          <Translate contentKey="home.title">Welcome, Java Hipster!</Translate>
        </h1>
        {account?.login ? (
          <div>
            <Alert color="success">
              <Translate
                contentKey="home.logged.message"
                interpolate={{ username: account.login, title: account.title, firstname: account.firstName, lastname: account.lastName }}
              >
                You are logged in as user {account.login} - {account.title} {account.firstName} {account.lastName}.
              </Translate>
            </Alert>
          </div>
        ) : (
          <div></div>
        )}
      </Col>
    </Row>
  );
};

export default Home;
